<template>
    <footer id="footer" class="bg-danger text-light">
        <span>Copyright <strong>Effis Tecnologia</strong> © 2020</span>
    </footer>
</template>

<script>

export default {
    name: "Footer",
    computed: {}
}
</script>

<style>
    #footer {
        position: absolute;

        bottom: 0;
        width: 100%;
        height: 40px;

        grid-area: footer;

        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
    }
</style>
